import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
Vue.use(Buefy)

import axios from 'axios';
Vue.prototype.$axios = axios  //全局注册，使用方法为: this.$axios

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
